import {athubAxios} from "../../../util/athub-axios";
import {ORGANIZATION_SERVER} from '@/api/server'

const permission = {
    findById: findById,
    childList: selectPermissionsByParentIdAndType,
    menus: selectMenus,
    menusSelect: selectMenusSelect,
    checkName: checkResourceNameAvailable,
    checkCode: checkResourceCodeAvailable,
    add: add,
    update: update,
    resourcesPage: selectResourcesPage,
    fullPath: selectFullPathById,
    bindModel: bindModel,
    selectModels: selectPermissionBindModelByPermissionId,
    page: page,
    valid: valid,
    invalid: invalid,
};

export function page(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permission/page`, params).then(res => {
            if (res.status === 200) {
                resolve(res);
            }
        });
    });
}

/**
 * 根据资源ID绑定模块/菜单
 * @param id 资源ID
 * @param modelIds 模块/菜单ID
 * @returns {Promise<unknown>}
 */
export function bindModel(id, modelIds) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permission/bind/${id}`, modelIds)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

export function selectPermissionsByParentIdAndType(pageSearch) {
    let url = `${ORGANIZATION_SERVER}/permission/child`;
    return new Promise(((resolve, reject) => {
        athubAxios.post(url, pageSearch)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 根据资源ID查询资源详情
 * @param id
 * @returns {Promise<unknown>}
 */
export function findById(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/permission/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 添加资源信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function add(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permission`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 修改资源信息
 * @param id 资源ID
 * @param params
 * @returns {Promise<unknown>}
 */
export function update(id, params) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/permission/${id}`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

export function selectMenus() {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/permission/menus`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

export function selectMenusSelect() {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/permission/menus/select`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 分页查询资源列表
 * @param param 搜索参数
 * @returns {Promise<unknown>}
 */
export function selectResourcesPage(param) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permission/resources/page`, param)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 检查资源名称是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkResourceNameAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permission/check/name`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 检查资源编码是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkResourceCodeAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permission/check/code`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 根据资源ID查询资源全路径
 * @param id 资源ID
 * @return 资源全路径
 */
export function selectFullPathById(id) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/permission/path/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 根据资源ID查询绑定的模块或菜单
 * @param id 资源ID
 * @returns {Promise<unknown>}
 */
export function selectPermissionBindModelByPermissionId(id) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/permission/model/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 启用
 * @param params
 * @returns {Promise<unknown>}
 */
export function valid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/permission/${id}/valid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 停用
 * @param params
 * @returns {Promise<unknown>}
 */
export function invalid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/permission/${id}/invalid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

export default permission;
